<template>
    <nav class="navbar navbar-expand-sm bg-dark navbar-dark">
        <div class="container-fluid">

        </div>
    </nav>
    <div class="container mt-4" style="text-align: center;">
        <h1 style="font-weight: bold;font-size: 40px;">您的帳號使用期限已到期</h1>
        <h1 style="font-weight: bold;font-size: 40px;">如要延長使用請聯繫管理人員，謝謝！</h1>
    </div>
</template>

<script>

export default {

    data() {
        return {
            systemName: window.VUE_APP_System, //recommend //behavior
            isDev: window.VUE_APP_Dev,
           
        }
    },
    beforeMount() {
        
       
    },
    mounted() {
        this.systemName = window.VUE_APP_System;
        if (this.systemName == "recommend") {
                //運動建議
                this.sportType = '運動項目推薦'
            } else {
                //運動行為
                this.sportType = '運動行為調查'
            }
    },
    computed: {
        
    },
    methods: {
        
    }
}
</script>